import { Label } from "components/atoms/form"

export const TextArea = ({
  label,
  register,
  required = false,
  type = "textarea",
  placeholder = "",
  errors = [""],
  name,
  defaultValue = "",
  rows = 5,
}) => (
  <div className="block w-full sm:inline-flex">
    <div className="w-full">
      <Label label={label} required={required} error={errors?.[name]} />
      <textarea
        className="block w-full px-3 py-2 leading-normal bg-white border rounded-lg appearance-none focus:outline-none focus:shadow-outline border-zinc-300 text-zinc-800"
        {...register(name, { required })}
        placeholder={placeholder}
        type={type}
        defaultValue={defaultValue}
        rows={rows}
      />
    </div>
  </div>
)
